export default class MovieClipUtil {
    /**
     * Gets first bitmap in children.
     * @param {createjs.MovieClip} movieClip 
     * @returns 
     */
    static getFirstBitmapChild(movieClip) {
        return movieClip.children.find(child => child instanceof createjs.Bitmap);
    }

    static gotoAndPlayAllChildren(movieClip, frame) {
        movieClip.children.forEach(child => {
            if (child instanceof createjs.MovieClip) {
                child.gotoAndPlay(frame);
            }
        });
    }

    /**
     * Animates a movieclip's timeline to a target frame.
     * @param {createjs.MovieClip} movieClip 
     * @param {number} targetFrame 
     * @param {number} duration 
     * @param {number} ease createjs.Ease
     * @returns {createjs.Tween}
     */
    static animateToFrame(movieClip, targetFrame, duration, ease, onChangeCallback) {
        ease = ease || createjs.Ease.linear;

        const proxy = { currentFrame: movieClip.currentFrame };
        const onChange = () => {
            movieClip.gotoAndStop(Math.round(proxy.currentFrame));
            
            if (onChangeCallback) {
                onChangeCallback({
                    currentFrame: proxy.currentFrame,
                });
            }
        };

        return createjs.Tween.get(proxy, { onChange })
            .to({ currentFrame: targetFrame }, duration, ease);
    }

    /**
     * Plays a timeline of a movieclip and returns when it reaches a stop frame.
     * @param {createjs.MovieClip} movieClip 
     * @param {number|string} positionOrLabel 
     */
    static async gotoAndPlayUntilPause(movieClip, positionOrLabel) {
        return new Promise(resolve => {
            const onChange = () => {
                if (!movieClip.paused) {
                    return;
                }

                movieClip.timeline.removeEventListener("change", onChange);
                resolve();
            }
            movieClip.timeline.addEventListener("change", onChange);
            movieClip.gotoAndPlay(positionOrLabel);
        });
    }
}